/**
 * FoodPulse PWA service-worker registration.
 * - Only runs in production builds (dev servers hot-reload on their own).
 * - Registers `/service-worker.js` scoped to `/` after the load event.
 * - Emits a `sw:update-ready` window event when a new worker is waiting so
 *   `<PwaInstallPrompt />` (or any UI) can prompt the user to refresh.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Allow developers to opt-in via localStorage; the /admin/cms preview flow
  // uses this to smoke-test the SW without publishing a prod build.
  const forceEnable = (() => {
    try {
      return localStorage.getItem("fp_pwa_enabled") === "1";
    } catch {
      return false;
    }
  })();
  if (process.env.NODE_ENV !== "production" && !forceEnable) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // If there's an updated worker waiting, notify the app shell.
        if (reg.waiting) {
          window.dispatchEvent(new CustomEvent("sw:update-ready", { detail: reg }));
        }
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("sw:update-ready", { detail: reg }));
            }
          });
        });
      })
      .catch((err) => {
        // Never break the app because the SW couldn't register.
        // eslint-disable-next-line no-console
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });
}

/** Ask the waiting worker to activate immediately, then reload the page. */
export function applyServiceWorkerUpdate(registration) {
  if (!registration || !registration.waiting) {
    window.location.reload();
    return;
  }
  registration.waiting.postMessage({ type: "SKIP_WAITING" });
  registration.waiting.addEventListener("statechange", (e) => {
    if (e.target.state === "activated") window.location.reload();
  });
}
